// Campus photo for /colleges/university-of-alabama: Public domain, by Carol M. Highsmith, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ADenny_Chimes_is_a_115_feet_(35_m)_tall_campanile_equipped_with_a_25-bell_carillon%2C_located_on_the_south_side_of_The_Quad_of_the_University_of_Alabama_in_Tuscaloosa%2C_Alabama_LCCN2010638248.tif), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-alabama/; credited under the photo.
const photo = {
    "slug": "university-of-alabama",
    "alt": "Denny Chimes rising above the trees on the Quad at The University of Alabama in Tuscaloosa",
    "src": "/colleges/university-of-alabama/campus-1600.webp",
    "srcSmall": "/colleges/university-of-alabama/campus-800.webp",
    "srcMid": "/colleges/university-of-alabama/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-alabama/og.jpg",
    "title": "Denny Chimes is a 115 feet (35 m) tall campanile equipped with a 25-bell carillon, located on the south side of The Quad of the University of Alabama in Tuscaloosa, Alabama LCCN2010638248",
    "author": "Carol M. Highsmith",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ADenny_Chimes_is_a_115_feet_(35_m)_tall_campanile_equipped_with_a_25-bell_carillon%2C_located_on_the_south_side_of_The_Quad_of_the_University_of_Alabama_in_Tuscaloosa%2C_Alabama_LCCN2010638248.tif",
    "read": "2026-10-01"
};

export default photo;
